import { forwardRef } from 'react';
import cx from 'classnames';
import PT, { InferProps } from 'prop-types'; // eslint-disable-line @typescript-eslint/no-unused-vars
import style from './Button.scss';

/**
 * Need to override implicit react type here as we're using forwardRef
 * and the TS intrinsic attributes don't work it out
 * @type {React.FC<InferProps<Button.propTypes>>}
 * @returns React.ReactElement
 */
const Button = forwardRef(
  (
    {
      children,
      secondary,
      outline,
      clear,
      small,
      icon,
      disabled,
      selected,
      className,
      ...props
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        className={cx(style.button, className, {
          [style.secondary]: secondary,
          [style.outline]: outline || clear,
          [style.clear]: clear,
          [style.small]: small,
          [style.selected]: selected,
        })}
        disabled={disabled}
        {...props}
      >
        {icon ? (
          <span
            className={cx(`icon-${icon}`, style.icon, {
              [style.smallIcon]: small,
            })}
          />
        ) : null}
        {children}
      </button>
    );
  }
);

Button.propTypes = {
  children: PT.node,
  secondary: PT.bool,
  outline: PT.bool,
  clear: PT.bool,
  small: PT.bool,
  icon: PT.string,
  disabled: PT.bool,
  selected: PT.bool,
  className: PT.string,
};

Button.defaultProps = {
  children: null,
  secondary: false,
  outline: false,
  clear: false,
  small: false,
  icon: '',
  disabled: false,
  selected: false,
  className: '',
};
Button.displayName = 'Button';

export default Button;
